import { IPromise } from 'q';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Messages } from '../../../codegen/Localize';
import { SiteStore } from '../../../common/react/SiteStore';
import { SiteNameSansIds } from '../../../ts/siteManagement/services/resources/SiteNameSansIds';
import { ISiteNameSansId } from '../../../ts/ServerApi/types/ISiteNameSansId';
import { SiteNamesRequest } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { SiteNamesRequestAction, siteNamesRequestSucceeded } from '../../actions/spaces/SitesNamesRequestAction';

export function* handleGetSitesRequest(action: SiteNamesRequestAction) {
  try {
    const sites: ReadonlyArray<ISiteNameSansId> = yield call(getSiteNamesRequest);
    yield put(siteNamesRequestSucceeded(sites));
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function getSiteNamesRequest(): IPromise<ISiteNameSansId[]> {
  const siteStore = new SiteStore(SiteNameSansIds.instance);
  return siteStore.getAll();
}

export function* rootSiteSagas(): SagaIterator {
  yield takeLatest(SiteNamesRequest, handleGetSitesRequest);
}

